import React from "react";
import { css } from "@emotion/core";
import PacmanLoader from "react-spinners/PacmanLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const Loader = (props)=>{
  console.log("Loader.js "+props);

  
    return (
      <div className="sweet-loading">
        <PacmanLoader
          css={override}
          size={25}
          color={"#123abc"}
          loading={props.loading}
        />
      </div>
    );
  
}

export default Loader;
